<script type="ts">
  import { format, register } from "timeago.js";
  import de from "timeago.js/lib/lang/de";
  import PlayerChipList from "../player_chips/PlayerChipList.svelte";
  import { gameState } from "../../store";
  import { store } from "../../store";

  export let game: Game;

  register("de", de);
  $: timeAgo = format(game.date, "de");

  const onCardClick = (_) => {
    gameState.update((state) => {
      return { ...state, currentGame: game.id };
    });
  };

  const onDelete = (_) => {
    store.update((current) => {
      return current.filter((item) => item.id != game.id);
    });
  };
</script>

<card
  class="my-4 shadow-md cursor-pointer card w-100 bg-base-100 hover:bg-base-200"
  on:click={onCardClick}
  on:keydown={() => {}}
>
  <div class="p-6 card-body">
    <div class="flex flex-row justify-between">
      <div>
        {#if game.name != undefined}
          <h2 class="card-title">{game.name}</h2>
        {/if}
        <p>{timeAgo}</p>
      </div>
      <button class="btn btn-square btn-outline" on:click={onDelete}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          /></svg
        >
      </button>
    </div>
    <div class="flex-wrap">
      <PlayerChipList players={game.players} centered={false} />
    </div>
  </div>
</card>
